import { TransactionAlertsLevels, Direction } from '@/api/complianceAPI/models';

import { nullLevels } from './TransactionAlerts.constants';

type EmptyCategoryLevels = Record<
  string,
  {
    income: { direct: typeof nullLevels; indirect: typeof nullLevels };
    outcome: { direct: typeof nullLevels; indirect: typeof nullLevels };
  }
>;

export const getTransactionAlertsEmptyData = (
  categories: string[],
): TransactionAlertsLevels =>
  categories.reduce<EmptyCategoryLevels>((acc, category) => {
    acc[category] = {
      income: {
        direct: { ...nullLevels },
        indirect: { ...nullLevels },
      },
      outcome: {
        direct: { ...nullLevels },
        indirect: { ...nullLevels },
      },
    };
    return acc;
  }, {} as EmptyCategoryLevels) as TransactionAlertsLevels;

export const getFilteredByDirectionLevelsData = (
  levels: TransactionAlertsLevels,
  currentDirection: Direction,
): TransactionAlertsLevels => {
  if (!levels) return {};

  return Object.fromEntries(
    Object.entries(levels)
      .filter(([, directions]) => directions?.[currentDirection])
      .map(([category, directions]) => [
        category,
        { [currentDirection]: directions[currentDirection] },
      ]),
  );
};
